import { AxiosResponse } from 'axios';
import { HttpClient } from '../../../HttpClient';
import { Maybe } from '../../../types';
import { OutreachTypes, SignalApiUrls } from '../../../urls';
import { OutreachMetadataResponse } from '../types';

export default class MetadataClient extends HttpClient {
  async fetchMetadata(): Promise<AxiosResponse<Maybe<any>>> {
    const response = await this.get<AxiosResponse<Maybe<any>>>(
      SignalApiUrls.getMetadataUrl(),
    );
    return response;
  }

  async fetchAllowedValues(
    partnerId: string,
    columnName: string,
  ): Promise<AxiosResponse<Maybe<string[]>>> {
    const response = await this.get<AxiosResponse<Maybe<string[]>>>(
      SignalApiUrls.getAllowedValuesUrl(partnerId, columnName),
    );
    return response;
  }

  async fetchOutreachMetadata(
    partnerId: string,
    monitorId: string,
    outreachType: OutreachTypes,
  ): Promise<OutreachMetadataResponse> {
    const response = await this.get<AxiosResponse<OutreachMetadataResponse>>(
      SignalApiUrls.getOutreachMetaData(partnerId, monitorId, outreachType),
    );
    return response.data;
  }
}
